import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncAccountCreateUser({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/accountCreateUser"));
  console.log("Loading", AsyncAccountCreateUser.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncAccountCreateUser;
